<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      size="small"
      :rules="rules"
    >
      <div class="d-flex">
        <div class="left">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="d-flex">
                <div class="side-frame"></div>
                <div>
                  <span style="font-size: 14px; color: #606266">
                    {{
                      $l('process_sheet_group_title_process_drawing') ||
                        '工艺图'
                    }}
                  </span>
                </div>
              </div>
              <TechImage
                v-model="formData.processDrawing"
                :disabled="disabled"
              />
            </el-col>
            <el-col :span="24">
              <div class="d-flex mt-2">
                <div class="side-frame-danger"></div>
                <div>
                  <span style="font-size: 14px; color: #606266">
                    {{ $l('process_sheet_group_title_crop_graph') || '裁剪图' }}
                  </span>
                </div>
              </div>
              <TechImage v-model="formData.cropGraph" :disabled="disabled" />
            </el-col>
          </el-row>
        </div>
        <div class="right">
          <div class="d-flex">
            <div class="side-frame-success"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                Tech No：{{ formData.techNo ? formData.techNo : 'New' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Order Goods Spec：{{ formData.identifyNo || '--' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <b-badge
                style="font-size: 12px"
                :variant="
                  formData.techStatus === 'N'
                    ? 'primary'
                    : formData.techStatus === 'S'
                    ? 'success'
                    : 'danger'
                "
              >
                {{ formData.v_techStatus }}
              </b-badge>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Update：{{
                  formData.modifyByName ? formData.modifyByName : '--'
                }}
                at
                {{ formData.modifyTime ? formData.modifyTime : '--' }}
              </span>
            </div>
          </div>
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item
                :label="$l('form_label_tech_name') || '工艺单名称'"
                prop="techName"
              >
                <el-input
                  size="small"
                  v-model="formData.techName"
                  maxlength="50"
                  show-word-limit
                  clearable
                  :placeholder="
                    $l('form_placeholder_tech_name') || '请输入工艺单名称'
                  "
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_effective_date') || '生效日期'"
                prop="effectiveDate"
              >
                <el-date-picker
                  size="small"
                  v-model="formData.effectiveDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('form_placeholder_effective_date') || '请选择生效日期'
                  "
                  style="width: 100%"
                  :picker-options="{
                    disabledDate(date) {
                      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    },
                  }"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_orderGoodsInfo') || '订单产品'"
              >
                <el-input
                  size="small"
                  type="textarea"
                  :autosize="{ minRows: 4 }"
                  clearable
                  v-model="formData.goodsDisplay"
                  readonly
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_tech_desc') || '工艺要求'">
                <el-input
                  v-model="formData.technologyDesc"
                  :placeholder="
                    $l('form_placeholder_tech_desc') || '请输入工艺要求'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 7 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_tolerances_desc') || '公差要求'"
              >
                <el-input
                  v-model="formData.tolerancesDesc"
                  :placeholder="
                    $l('form_placeholder_tolerance_desc') || '请输入公差要求'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 7 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_appearance_desc') || '外观要求'"
              >
                <el-input
                  v-model="formData.surfaceDesc"
                  :placeholder="
                    $l('form_placeholder_appearance_desc') || '请输入外观要求'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 7 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('form_label_other_desc') || '其他要求'">
                <el-input
                  v-model="formData.otherDesc"
                  :placeholder="
                    $l('form_placeholder_other_desc') || '请输入其他要求'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 7 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_tech_remark') || '工艺单备注说明'"
              >
                <el-input
                  size="small"
                  v-model="formData.techRemark"
                  :placeholder="
                    $l('form_placeholder_tech_remark') || '请输入工艺单备注说明'
                  "
                  clearable
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 4 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="d-flex mt-2">
            <div class="side-frame-warning"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                Create：{{
                  formData.createByName ? formData.createByName : '--'
                }}
                at
                {{ formData.createTime ? formData.createTime : '--' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Submit：{{
                  formData.submitByName ? formData.submitByName : '--'
                }}
                at
                {{ formData.submitTime ? formData.submitTime : '--' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <span style="font-size: 14px; color: #606266">
                Review：{{
                  formData.reviewByName ? formData.reviewByName : '--'
                }}
                at
                {{ formData.reviewTime ? formData.reviewTime : '--' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button
          @click="() => this.$emit('save')"
          type="primary"
          size="small"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import TechImages from '../tech-images'
import TechImage from '../tech-image'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
export default {
  components: { TechImage },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    techCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
    identifyGoodsName: { type: String, default: '' },
    orderGoodsSpecCode: { type: String, default: '' },
    techGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        effectiveDate: dayjs(new Date()).format('YYYY-MM-DD'),
        identifyNo: '',
      },
      rules: {
        techName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_tech_name') || '请输入工艺单名称',
            trigger: 'blur',
          },
        ],
        effectiveDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_effective_date') || '请选择生效日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    orderGoodsSpecCode: {
      handler(val) {
        if (val && !this.techCode) this.formData.orderGoodsSpecCode = val
      },
      immediate: true,
    },
    orderCode: {
      handler(val) {
        if (val && !this.techCode) this.formData.orderCode = val
      },
      immediate: true,
    },
    productLine: {
      handler(val) {
        if (val && !this.techCode) this.formData.productLine = val
      },
      immediate: true,
    },
    identifyGoodsName: {
      handler(val) {
        if (val && !this.techCode) this.formData.identifyNo = val
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techCode) return
      this.$api
        .techInfoDetailApi({
          techCode: this.techCode,
        })
        .then((res) => {
          this.formData = res.body
          this.$emit('update:orderCode', this.formData.orderCode)
          this.$emit('update:productLine', this.formData.productLine)
          this.$emit(
            'update:orderGoodsSpecCode',
            this.formData.orderGoodsSpecCode
          )
          this.$emit(
            'update:techGoodsSpecCode',
            this.formData.techGoodsSpecCode
          )
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const { processDrawing = {}, cropGraph = {} } = this.formData

      this.loadingOpen()
      this.formData.cropGraph = await this.fileHander(cropGraph)
      this.formData.processDrawing = await this.fileHander(processDrawing)
      this.$api
        .techInfoSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }

          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })

          if (!this.techCode) {
            this.$router.replace({
              name: 'technology-processSheet-detail',
              params: {
                techCode: res.body,
                pageType: 'edit',
              },
            })
            return
          }
          this.getData() // 刷新图片信息
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async fileHander(file) {
      if (!file) return {}
      if (file.originImageUrl) return file
      return await this.uploadFile(file)
    },
    uploadFile(readyFile) {
      if (!readyFile || !readyFile.raw) {
        return Promise.resolve({})
      }
      return this.$api.SYS_UPLOAD(readyFile.raw).then((res) => ({
        originImageCode: res.body.fileId,
        originImageUrl: res.body.url,
        originImageSpec: readyFile.raw.type,
        thumbImageCode: res.body.thumbnailFileId,
        thumbImageUrl: res.body.thumbnailUrl,
        uid: readyFile.uid,
      }))
    },
  },
}
</script>
<style lang="scss" scoped>
.el-textarea .el-input__count {
  background-color: transparent;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
.left {
  width: 400px;
  margin-right: 15px;
}
.right {
  width: 100%;
}
</style>
